module.exports = __webpack_public_path__ + "img/projects-active.43956de8.svg";